import { Avatar, Box, Menu, Text, UnstyledButton } from "@mantine/core";
import { IconLogout, IconUserCircle, IconChevronDown } from "@tabler/icons-react";
import type { Session } from "../auth/AuthContext.js";

interface UserMenuProps {
  session: Session;
  onLogout: () => void;
}

/**
 * Header user chip: avatar with the user's initial, display name + handle,
 * dropdown menu with logout. Used by both customer and admin shells.
 * The name pair collapses to avatar-only on very narrow viewports.
 */
export function UserMenu({ session, onLogout }: UserMenuProps) {
  const initial = (session.display_name || session.username || "?")
    .trim()
    .charAt(0)
    .toUpperCase();
  const name = session.display_name || session.username;
  return (
    <Menu shadow="md" width={220} position="bottom-end" withArrow>
      <Menu.Target>
        <UnstyledButton
          aria-label="Account menu"
          className="proxvps-hover-chip"
          px="6px"
          py="4px"
          style={{ borderRadius: 8, display: "flex", alignItems: "center", gap: 8 }}
        >
          <Avatar color="brand" variant="filled" radius="xl" size={30}>
            {initial}
          </Avatar>
          <Box visibleFrom="xs" style={{ minWidth: 0, lineHeight: 1.1 }}>
            <Text size="sm" fw={600} lineClamp={1} style={{ whiteSpace: "nowrap" }}>
              {name}
            </Text>
            <Text size="xs" c="dimmed" lineClamp={1} style={{ whiteSpace: "nowrap" }}>
              @{session.username}
            </Text>
          </Box>
          <Box visibleFrom="xs">
            <IconChevronDown size={14} style={{ opacity: 0.6 }} />
          </Box>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>Signed in as</Menu.Label>
        <Text size="xs" c="dimmed" px="sm" pb={4} truncate>
          {session.username}
        </Text>
        <Menu.Divider />
        <Menu.Item leftSection={<IconUserCircle size={16} />} disabled>
          Profile
        </Menu.Item>
        <Menu.Item leftSection={<IconLogout size={16} />} color="red" onClick={onLogout}>
          Log out
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
